import React from 'react'
import { useCountDown } from 'hooks'
import styles from './ActionCampaigns.module.scss'

const ActionCampaigns = ({ titleCountDown, campaignsData }) => {
  const { renderCountDown } = useCountDown({
    titleCountDown,
    styles,
    callOn: 'AuctionCampaigns',
  })
  return renderCountDown({ campaignsData })
}

export default React.memo(ActionCampaigns)
